<template>
  <div class="container-fluid controller">
    <div class="container">
    <div class="portfolio-wrapper port-v2 space-fix section-gap">
      <div class="container-fluid trans">
        <div class="row no-gutter">
          <div
            class="col-sm-12 col-md-6 col-lg-4"
            v-for="(portfolio,index) of portfoliov2.data"
            :key="index"
          >
            <div class="overlay-wrap">
              <div>
                <img
                  v-if="index <= 5"
                  :src="portfolio.thumb_image_path"
                  width="500"
                  height="500"
                  class="img-fluid w-100"
                  alt="gallery images"
                />

                <div v-if="index <= 5" class="card-img-overlay primary-tp-layer text-center d-flex justify-content-center">
                  <div onclick="" class="align-self-center">
                    <a :href="portfolio.image_path" data-fancybox="images" class>
                      <div class="ih-fade-down square-40 rounded-circle bg-white shadow-md">
                        <i class="fa fa-plus align-middle"></i>
                      </div>
                    </a>
                    <h3 class="mb-0 mt-4 text-white">{{ portfolio.title }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         <TestimonialSlider />
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import portfoliov2 from "Components/data/portfolio-v2.json";
import TestimonialSlider from "Components/Sections/TestimonialSlider.vue";
export default {
  data() {
    return {
      portfoliov2,
    };
  },
   components: {
    TestimonialSlider,
}
};
</script>
<style scoped>
  .port-v2 img {
    /* height: auto !important; */
    height: 250px;
  }

  .section-gap {
    padding-top: 0 !important;
  }

  .container-fluid {
    background: black !important;
  }
  .primary-tp-layer {
    border-radius: 10px;
    background: #eb6626;
    background: rgba(235, 102, 3, 0.8);
}
.controller {
  /* background-image: url(/static/img/controller-l.png) !important;
  background-repeat: no-repeat !important;
  background-position:-10% 118% !important; */
  
}
.trans {
  background-color: transparent !important;
}
</style>

